import { defineStore } from 'pinia';

export const PATTY_MODES = Object.freeze({
    GENERAL: 'GENERAL',
    AUDIT_AGENT: 'AUDIT_AGENT',
});

const auditContext = (context = {}) => {
    const siteId = Number(context.siteId);
    return {
        ...(Number.isSafeInteger(siteId) && siteId > 0 ? { siteId } : {}),
        ...(typeof context.auditHash === 'string' && context.auditHash.trim()
            ? { auditHash: context.auditHash.trim() }
            : {}),
    };
};

export const usePattyStore = defineStore('patty', {
    state: () => ({
        activeTab: 'NEW',
        isPanelVisible: false,
        threadId: null,
        queryText: '',
        mode: PATTY_MODES.GENERAL,
        context: {},
    }),
    actions: {
        openNew() {
            /**
             * Open the messenger panel to the "New Message" tab
             */
            this.isPanelVisible = true;
            this.activeTab = 'NEW';
            this.threadId = null;
            this.queryText = '';
            this.mode = PATTY_MODES.GENERAL;
            this.context = {};
        },

        openAudit(context = {}) {
            this.isPanelVisible = true;
            this.activeTab = 'NEW';
            this.threadId = null;
            this.queryText = '';
            this.mode = PATTY_MODES.AUDIT_AGENT;
            this.context = auditContext(context);
        },

        openHistory() {
            this.isPanelVisible = true;
            this.activeTab = 'HISTORY';
        },

        openThread(threadIdOrQueryText) {
            if (this.mode === PATTY_MODES.AUDIT_AGENT) {
                this.threadId = threadIdOrQueryText;
                this.queryText = '';
            } else {
                this.threadId =
                    typeof threadIdOrQueryText == 'string'
                        ? -1
                        : threadIdOrQueryText;
                this.queryText =
                    typeof threadIdOrQueryText != 'string'
                        ? ''
                        : threadIdOrQueryText;
            }
            this.isPanelVisible = true;
            this.activeTab = 'THREAD';
        },

        startThread(queryText) {
            this.threadId = this.mode === PATTY_MODES.AUDIT_AGENT ? null : -1;
            this.queryText = queryText;
            this.isPanelVisible = true;
            this.activeTab = 'THREAD';
        },

        openNewInCurrentMode() {
            if (this.mode === PATTY_MODES.AUDIT_AGENT) {
                this.openAudit(this.context);
            } else {
                this.openNew();
            }
        },

        setQueryText(text) {
            this.queryText = text;
        },

        closePanel() {
            this.isPanelVisible = false;
        },
    },

    getters: {},
});
